import { all, call, put, takeLatest } from '@redux-saga/core/effects'
import { MENU, START } from '../../types/action-types'
import { getBusinessMenu, getMenu } from '../../../api/Menu'
import { menuRequestError, menuRequestSuccess } from '../../actions/Menu'

export default function* menuWatcher() {
  yield takeLatest(`${MENU}${START}`, menuWorker)
}

function* menuWorker({ payload: { restId, date } }) {
  try {
    const [menuResponse, businessMenuResponse] = yield all([call(getMenu, restId), call(getBusinessMenu, restId, date)])

    yield put(
      menuRequestSuccess({
        menu: menuResponse.data.data,
        businessMenu: businessMenuResponse.data.data,
      })
    )
  } catch (error) {
    yield put(menuRequestError(error))
  }
}
